import { createApp } from 'vue'
import Markup from './Markup.vue'
import './assets/global.css'

createApp(Markup).mount('#markup')
